import SelectedContactList from './SelectedContactList';

export default SelectedContactList;